import CertificationModule from '@/modules/certification';
import ContratoRastreabilidadeModule from '@/modules/traceability-contract';
import RelatorioRastreabilidadeModule from '@/modules/traceability-report';

const modules = [RelatorioRastreabilidadeModule, ContratoRastreabilidadeModule, CertificationModule];

export const ModuleService = {
    install: (router, i18n) => {
        modules.forEach(module => {
            module.routes.forEach(route => {
                router.addRoute(route);
            });
            Object.keys(module.locales).forEach(key => {
                const values = {
                    [module.name]: module.locales[key]
                };
                i18n.mergeLocaleMessage(key, values);
            });
        });
    }
};
